import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateLoader } from "ng2-translate";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Urls, environment } from "../../../environments/environment";
var cache = {};
@Injectable({
  providedIn: "root",
})
export class LocalizeService implements TranslateLoader {
  constructor(private httpClient: HttpClient) { }
  getTranslation(lang?: any,apiFailed?:boolean): Observable<any> {
    if (cache[lang]) {
      return of(cache[lang]);
    }

    lang = lang ? lang : "en";

    let apiAddress = `${Urls.final_url}translator/getStringsJson`;

    // For Local
    // if (!environment.production && lang == 'en') {
    //   apiAddress = 'assets/i18n/en.json'
    // }
    
   let params = new HttpParams()

    if(apiFailed){
      apiAddress = 'assets/i18n/en.json'
    }else{
      params = params.set("appName", "AFCS-Frontend");
      params = params.set("language", lang);
    }

    return this.httpClient
      .get(apiAddress, {params: params })
      .pipe(
        map((translationData: any) => {
          cache[lang] = translationData;
          window.postMessage({currentLang:lang})
          return translationData;
        }),
        catchError((error) => {
          console.error("Error fetching translation data:", error);
          this.getTranslation(lang,true).subscribe()
          return of({});
        })
      );
  }

  getLanguages() {
    let params = new HttpParams()
      .set("appName", "AFCS-Frontend")

    let url = `${Urls.final_url}translator/getRequestedLanguages`;
    return this.httpClient.get(url,{params:params});
  }
}
